import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { SearchBankAccountModel } from '../models/search-bank-accounts-changes.model';
import { BankAccountChangesModel } from '../models/bank-account-changes.model';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { EmployeeBankAccountService } from '../services/employee-bank-account.service';

@Component({
  selector: 'app-employee-bank-account-changes',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, MatPaginatorModule, MatTableModule],
  templateUrl: './employee-bank-account-changes.component.html',
  styleUrl: './employee-bank-account-changes.component.scss'
})
export class EmployeeBankAccountChangesComponent implements OnInit {
  searchForm: FormGroup;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  searchRequestParams: SearchParameters<SearchBankAccountModel>;
  isLoading: boolean = false;
  pagedData: PagedResult<BankAccountChangesModel[]>;
  totalCount: number;
  pageSize: number = 10;
  pageIndex: number;
  dataSource: MatTableDataSource<BankAccountChangesModel>;
  searchDone: boolean = false;
  displayedColumns: string[] = ['number', 'time', 'action', 'employeeName', 'bankAccount', 'actionBy'];

  constructor(
      private userService: LoggedInUserService,
      private fb: FormBuilder,
      private employeeBankAccountService: EmployeeBankAccountService, ) {}


  ngOnInit(): void {
    this.searchForm = this.fb.group({
      employeeName: new FormControl(''),          
      bankAccount: new FormControl(''),
      fromDate: new FormControl(''),
      toDate: new FormControl('')
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;        
      }      
    });
  }

  submitForm(): void { 
      this.searchRequestParams = {
        query: {
          employeeName: this.searchForm.get('employeeName').value || null,
          bankAccount: this.searchForm.get('bankAccount').value || null,
          fromDate: this.searchForm.get('fromDate').value || null,
          toDate: this.searchForm.get('toDate').value || null
        },
        pageIndex: 0,
        pageSize: 10,
        userEmail: this.user.userEmail      
      };
      
      this.search();
    }
  
    search() {
      if(this.isAdmin){
        this.isLoading = true;
        this.employeeBankAccountService.searchBankAccountChanges(this.searchRequestParams)
          .subscribe(data => {
            this.pagedData = data;
            this.pageSize = this.pagedData.pageSize;
            this.totalCount = this.pagedData.totalCount;      
            this.dataSource = new MatTableDataSource<BankAccountChangesModel>(this.pagedData.items);
            this.isLoading = false;
            this.searchDone = true;
        });
      }
      else{
        this.dataSource = new MatTableDataSource<BankAccountChangesModel>([]);
      }
    }
    
    public pageChangeEvent(event?: PageEvent){
        this.searchRequestParams.pageIndex = event.pageIndex;
        this.searchRequestParams.pageSize = event.pageSize;
        this.search();
      }  
}
